<template>
	<div>
		<div class="text-h5">Tambah Pengiriman Transfer Stok</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-autocomplete :items="optionTOforTDO" v-model="to_selected" item-value="to_code" label="Transfer Stok" no-data-text="Tidak ada data yang sesuai" outlined dense>
										<template v-slot:item = {item}>
											{{ item.to_code }} - {{ item.warehouse_name }}
										</template>
										<template v-slot:selection = {item}>
											{{ item.to_code }}
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0" v-if="false">
									<v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_sent_date)" label="Estimasi Kirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
										</template>
										<v-date-picker locale="id" color="primary" @input="menu = false" v-model="est_sent_date"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_received_date)" label="Estimasi Terima" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense :error-messages="responseError.estimated_received_date"></v-text-field>
										</template>
										<v-date-picker locale="id" color="primary" @input="menu2 = false; responseError.estimated_received_date = '';" v-model="est_received_date"></v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-textarea v-model="note" label="Catatan" outlined dense height="120" hide-details="auto" no-resize></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="detailTO.to_detail" hide-default-footer no-data-text="Tidak ada data tersedia">
								<template v-slot:item.to_detail_product_name="{ item }">
									<div class="pt-2">{{ item.to_detail_product_name }}</div>
								</template>
								<template v-slot:item.to_detail_product_code="{ item }">
									<div class="pt-2">{{ item.to_detail_product_code }}</div>
								</template>
								<template v-slot:item.to_detail_quantity_requested="{ item }">
									<div class="pt-2">{{ item.to_detail_quantity_requested | toNumber }}</div>
								</template>
								<template v-slot:item.to_detail_quantity_transport="{ item }">
									<div class="pt-2">{{ item.to_detail_quantity_transport | toNumber }}</div>
								</template>
								<template v-slot:item.to_detail_quantity_sent="{ item }">
									<div class="pt-2">{{ item.to_detail_quantity_sent | toNumber }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<v-currency-field outlined dense class="py-3" v-model="item.to_detail_quantity_remaining" hide-details="auto" :disabled="item.product_is_serial_digital == 'true'"></v-currency-field>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" depressed class="text-capitalize" @click="proccess">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'

export default {
	inject: ['theme'],
	data() {
		return {
			menu: false,
			menu2: false,
			list_payment: ['Lunas', 'Tempo'],
			to_selected: '',
			est_sent_date: '',
			est_received_date: '',
			note: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'to_detail_product_name', sortable: true},
			{ text: 'Kode Produk', value: 'to_detail_product_code', sortable: false},
			{ text: 'Jumlah Permintaaan', value: 'to_detail_quantity_requested', align: 'end', width: "18%"},
			{ text: 'Jumlah Dikirim', value: 'to_detail_quantity_transport', align: 'end', width: "15%"},
			{ text: 'Jumlah Terkirim', value: 'to_detail_quantity_delivered', align: 'end', width: "15%"},
			{ text: 'Jumlah Kirim', value: 'quantity', align: 'end', width: "15%"},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('to', ['detailTO']),
		...mapState('tdo', ['optionTOforTDO', 'response', 'responseError', 'alertMultiple']),
		...mapGetters('to', ['productTO']),
	},
	methods: {
		...mapActions('to', ['getDetailTO']),
		...mapMutations('to', ['setDetailTO']),
		...mapActions('tdo', ['getOptionTOforTDO', 'createTDO']),
		...mapMutations('tdo', ['saveResponse', 'clearDataTDO']),

		proccess(){
			let params = {
				to_id: this.detailTO.to_id,
				estimated_sent_date: this.est_sent_date,
				estimated_received_date: this.est_received_date,
				note: this.note,
				product: this.productTO.map((el) => {
					return {
						product_id: el.to_detail_product_id,
						product_name: el.to_detail_product_name,
						quantity: el.to_detail_quantity_remaining
					}
				})
			}
			this.createTDO(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
		},
		resetForm(){
			this.saveResponse({
				code: '',
				message: ''
			})
			this.setDetailTO({})
			this.to_selected = ''
			this.est_sent_date = ''
			this.est_received_date = ''
			this.note = ''
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Pengiriman Transfer Stok`)
		this.getOptionTOforTDO({limit: 100})
	},
	beforeDestroy() {
		this.clearDataTDO()
		this.setDetailTO({})
	},
	watch: {
		to_selected(val) {
			if (val) {
				this.getDetailTO(val)
			}
		}
	}
}
</script>